<span class="sui-file-input__field">
  <button
    type="button"
    class="sui-file-input__button"
    [id]="effectiveId"
    [disabled]="isDisabled()"
    [attr.aria-invalid]="errorState ? 'true' : null"
    (click)="open()"
    (blur)="markTouched()"
  >
    {{ buttonLabel }}
  </button>

  <span
    class="sui-file-input__name"
    [class.sui-file-input__name--placeholder]="empty"
    [title]="file?.name || placeholder"
  >
    {{ file?.name || placeholder }}
  </span>

  <fa-icon
    class="sui-file-input__invalid-icon"
    [icon]="faCircleExclamation"
    aria-hidden="true"
  ></fa-icon>

  <input
    #nativeInput
    type="file"
    class="sui-file-input__native"
    [accept]="accept"
    [disabled]="isDisabled()"
    (change)="onFileChange($event)"
    tabindex="-1"
    aria-hidden="true"
  />
</span>
